import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/models/user';
import { EstensioneService } from 'src/app/services/estensione.service';
import { ToastrService } from 'ngx-toastr';
import { extensions } from '../config'
import { Estensione } from 'src/app/models/estensione';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-integrazione-generali',
  templateUrl: './integrazione-generali.component.html',
  styleUrls: ['./integrazione-generali.component.scss']
})

export class IntegrazioneGeneraliComponent {
  
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private estensioneService: EstensioneService,
    private toast: ToastrService,
    private router: Router
  ) { }

  slug: string = 'generali';
  form: FormGroup;
  loggedInUser: User;
  params: any;
  //constantIMBuser: String = '1319e9d0-ae34-45ad-9e8b-475195c6f6f1'
  extension: Estensione

   async ngOnInit(): Promise<any> {
    this.loggedInUser = this.authService.loggedInUser.getValue();
  
   
    this.form = this.fb.group({
      username:  '',
      password:  '',
      client_id:  '',
      auth_client_id: '',
      auth_client_secret: '',
      url: '',
      enabled:  false,
    });

    try {
      this.extension = await this.estensioneService.bySlug(extensions.generali);
      console.log(this.extension)
      if (this.extension && this.extension.id) {
        this.form.patchValue({
          username: this.extension.configuration.username,
          password: this.extension.configuration.password,
          client_id: this.extension.configuration.client_id,
          url: this.extension.configuration.url,
          auth_client_id : this.extension.configuration.auth_client_id,
          auth_client_secret : this.extension.configuration.auth_client_secret,
          enabled: this.extension.enabled,
        }) 
      }
     } catch(e) {
      console.error(e)
     }
  }

  async Salva() {
    console.log(this.form);
    let conf = JSON.stringify({
        username: this.form?.value.username,
        password: this.form?.value.password,
        client_id: this.form?.value.client_id,
        url: this.form?.value.url,
        auth_client_id : this.form?.value.auth_client_id,
        auth_client_secret : this.form?.value.auth_client_secret,

      });
    this.params = {
      slug: extensions.generali,
      configuration: conf,
      enabled: this.form?.value.enabled ? this.form.value.enabled : false,
      studio_id: this.loggedInUser.studio_id
    }
    
    let res = await this.estensioneService.saveOrUpdate(this.params, this.slug);

    if (res.created && res.updated) {
     return this.toast.error("Errore nel server");
    }

    if (res.created) 
      return this.toast.success("Configurazione creata");

    if (res.updated)
      return this.toast.success("Configurazione salvata");
  }
}
